<template>
  <div class="button-back" @click="back">
    戻る
  </div>
</template>

<script>
export default {
  methods: {
    back: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-back {
  @include button-ol-primary;
}
</style>
